let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("98W0w"), load("hjLdU"), load("iLgOr"), load("dLkMK"), load("U7y88"), load("dwffN")]).then(() => parcelRequire('bvmt1'));